module.exports = __webpack_public_path__ + "static/media/fa-regular-400.c20b5b73.woff2";